import React from "react"
import CannyFeedbackSkeleton from "@/components/CannyFeedback/CannyFeedbackSkeleton"
import { useGlobalStateStore } from "@/store/GlobalState"

const CannyFeedback = () => {
	const [loading, setLoading] = React.useState(true)

	const globalStateStore = useGlobalStateStore()
	const ssoToken = globalStateStore.user.cannyToken

	React.useEffect(() => {
		window.Canny("render", {
			boardToken: "26e2e0d6-b2f6-143c-7a37-95e0984af255",
			basePath: "/admin/feedback/",
			ssoToken: ssoToken,
			theme: "light",
			onLoadCallback: () => {
				setLoading(false)
			}
		})
	})

	return (
		<>
			{/** The <Loading/> component is not being used here because the div with the data-canny attribute must always be "visible" to render and update the loading status */}
			{loading && (
				<CannyFeedbackSkeleton />
			)}
			<div data-canny ></div>
		</>
	)
}

export default CannyFeedback
